import Store from "@/store";

export default async (next) => {
    let is_created_order = await Store.getters['auth/is_created_order']
    if(is_created_order) {
        await Store.dispatch('edit/clearAll')
        await Store.dispatch('theme/clearAll')
        await Store.dispatch('music/clearAll')
        await Store.dispatch('entry_video/clearAll')
        await Store.dispatch('main_videos/clearAll')
        await Store.dispatch('ending_video/clearAll')
        await Store.dispatch('survey_price/setSelectSurveyPrice', {
            price: 0
        })
        await Store.dispatch('survey_price/setSelectSurveyName', {
            name: 'Без съемки'
        })
        await Store.dispatch('auth/setIsCreatedOrder', { status: false })
        await localStorage.clear()
    }
}